import { useState, useEffect, useRef } from "react";
import { ChevronDown, Search, Check } from "lucide-react";

// Searchable dropdown that keeps its option list UNTRANSLATED (data-notranslate),
// so country & language names always show in English regardless of app language.
export default function SearchableSelect({ value, onChange, options, placeholder = "Select…", testId }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const boxRef = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const filtered = options.filter((o) => o.toLowerCase().includes(q.toLowerCase()));

  return (
    <div ref={boxRef} className="relative" data-notranslate>
      <button type="button" data-testid={testId} onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between gap-2 px-3 py-2.5 rounded-xl border border-slate-200 bg-white text-sm text-left hover:border-[#1E5AA8] focus:outline-none focus:ring-2 focus:ring-[#1E5AA8]/30">
        <span className={value ? "text-slate-800" : "text-slate-400"}>{value || placeholder}</span>
        <ChevronDown className="w-4 h-4 text-slate-400 shrink-0" />
      </button>
      {open && (
        <div className="absolute z-40 mt-1 w-full rounded-xl border border-slate-200 bg-white shadow-lg overflow-hidden">
          <div className="p-2 border-b border-slate-100 sticky top-0 bg-white">
            <div className="relative">
              <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
              <input
                data-testid={`${testId}-search`}
                autoFocus
                value={q}
                onChange={(e) => setQ(e.target.value)}
                placeholder="Type to search…"
                className="w-full pl-8 pr-2 py-2 text-sm rounded-lg border border-slate-200 focus:outline-none focus:ring-2 focus:ring-[#1E5AA8]/30"
              />
            </div>
          </div>
          <div className="max-h-56 overflow-auto">
            {filtered.length === 0 && <p className="text-xs text-slate-400 text-center py-4">No matches</p>}
            {filtered.map((o) => (
              <button key={o} type="button" data-testid={`${testId}-option-${o}`}
                onClick={() => { onChange(o); setOpen(false); setQ(""); }}
                className={`w-full flex items-center justify-between text-left px-3 py-2 text-sm hover:bg-[#EBF3FB] ${o === value ? "text-[#1E5AA8] font-semibold" : "text-slate-700"}`}>
                {o}
                {o === value && <Check className="w-4 h-4" />}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
